export default function reducer(initialState, action) {

    let newState = {};

    switch (action.type) {

        case 'SET_MENU_LOCATION':
            //console.log(initialState);
            newState = { ...initialState, menuLocation: action.value };
            return newState;

        case 'SET_MESSAGE':
            //console.log(initialState);
            newState = { ...initialState, messageOptions: action.value };
            return newState;

        case 'SET_EMAIL':
            newState = { ...initialState, email: action.value };
            return newState;

        case 'SET_CUSTOMER_ALIAS':
            newState = { ...initialState, customerAlias: action.value };
            return newState;

        case 'SET_CUSTOMER_SETTINGS':
            newState = { ...initialState, customerSettings: action.value };
            return newState;

        case 'SET_USER_INTERACTED':
            newState = { ...initialState, userInteractedWithTheDocument: true };
            return newState;

        case 'SET_SELECTED_GUI_LANGUAGE':
            newState = { ...initialState, selectedGuiLanguage: action.value };
            return newState;

        case 'SET_EMAIL':
            newState = { ...initialState, email: action.value };
            return newState;

        case 'SET_ALIAS':
            newState = { ...initialState, alias: action.value };
            return newState;
        
        case 'INITIALIZE_ONESIGNAL':
            newState = { ...initialState, oneSignalInitialized: true };
            return newState;

        default:
            return initialState;
    }
}
